export const changeStep = (modal: HTMLElement, modalNextStep: HTMLButtonElement, modalFirstStep: HTMLElement, modalSecondStep: HTMLElement) => {
    if (modal && modalNextStep) {
        modalNextStep.addEventListener('click', () => {
            modalFirstStep.style.display = 'none';
            modalSecondStep.style.display = 'flex';
            modalNextStep.innerText = "Commencer mon témoignage"
        })
    }
}